<mat-nav-list>
    <a mat-list-item [routerLink]="'/dashboard'" (click)="onSidenavClose()">Home</a>
    <a mat-list-item [routerLink]="'/bank/accounts'" (click)="onSidenavClose()">Accounts</a>
    <a mat-list-item [routerLink]="'/assets'" (click)="onSidenavClose()">Assets</a>
    <a mat-list-item [routerLink]="'/debts'" (click)="onSidenavClose()">Debts</a>
    <a mat-list-item [routerLink]="'/admin'" (click)="onSidenavClose()">Admin</a>
</mat-nav-list>